var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeTemplate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 170,
    viewBox: "0 0 162 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.936 2.07031H64.458C60.0041 2.07031 56.3936 5.62769 56.3936 10.0159V133.264C56.3936 137.652 60.0041 141.209 64.458 141.209H151.936C156.39 141.209 160 137.652 160 133.264V10.0159C160 5.62769 156.39 2.07031 151.936 2.07031Z",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.185 16.5811H69.0722C66.8383 16.5811 65.0273 18.3183 65.0273 20.4612V36.602C65.0273 38.745 66.8383 40.4822 69.0722 40.4822H148.185C150.419 40.4822 152.23 38.745 152.23 36.602V20.4612C152.23 18.3183 150.419 16.5811 148.185 16.5811Z",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.197 26.8248C109.627 26.8248 110.787 25.6782 110.787 24.264C110.787 22.8497 109.627 21.7031 108.197 21.7031C106.766 21.7031 105.606 22.8497 105.606 24.264C105.606 25.6782 106.766 26.8248 108.197 26.8248Z",
    fill: "#D7E8F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.29 35.3611C101.29 33.5499 102.018 31.813 103.313 30.5325C104.608 29.2515 106.365 28.5322 108.197 28.5322C110.029 28.5322 111.786 29.2515 113.081 30.5325C114.377 31.813 115.104 33.5499 115.104 35.3611H101.29Z",
    fill: "#D7E8F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.055 66.9443C106.324 66.9453 103.653 67.7471 101.382 69.2482C99.1107 70.7494 97.3412 72.883 96.2961 75.3787C95.2514 77.8744 94.9785 80.6203 95.5122 83.2696C96.0459 85.9184 97.3615 88.3515 99.2941 90.2612C101.226 92.1709 103.688 93.4711 106.367 93.9978C109.047 94.5245 111.824 94.2537 114.348 93.2194C116.872 92.1857 119.029 90.4353 120.547 88.1893C122.065 85.9433 122.875 83.3031 122.875 80.6021C122.875 78.8082 122.517 77.0315 121.823 75.3744C121.128 73.7168 120.11 72.2109 118.827 70.9427C117.543 69.6745 116.02 68.6684 114.344 67.9824C112.667 67.2964 110.87 66.9434 109.055 66.9443ZM109.055 90.9639C108.537 90.9385 108.048 90.717 107.69 90.3453C107.331 89.9736 107.132 89.48 107.132 88.9667C107.132 88.4529 107.331 87.9592 107.69 87.5875C108.048 87.2158 108.537 86.9943 109.055 86.9694C109.574 86.9943 110.063 87.2158 110.421 87.5875C110.779 87.9592 110.979 88.4529 110.979 88.9667C110.979 89.48 110.779 89.9736 110.421 90.3453C110.063 90.717 109.574 90.9385 109.055 90.9639ZM111.605 75.6031C111.18 78.5642 110.822 81.6737 109.926 84.5536C109.714 85.2472 108.397 85.2472 108.185 84.5536C107.554 82.3884 107.069 80.1845 106.733 77.9567C106.457 76.335 105.499 73.7087 106.414 72.1348C107.222 70.6997 109.496 70.5561 110.817 71.2928C112.438 72.197 111.799 74.1296 111.605 75.6031Z",
    fill: "#D7E8F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6611 51.5791H141.005",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6611 58.4092H141.005",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6611 101.09H141.005",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0654 107.064H125.464",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5421 29.3857H10.0644C5.61055 29.3857 2 32.9431 2 37.3314V160.579C2 164.967 5.61055 168.525 10.0644 168.525H97.5421C101.996 168.525 105.607 164.967 105.607 160.579V37.3314C105.607 32.9431 101.996 29.3857 97.5421 29.3857Z",
    fill: "white",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7911 43.8975H14.6786C12.4447 43.8975 10.6338 45.6347 10.6338 47.7776V63.9184C10.6338 66.0614 12.4447 67.7986 14.6786 67.7986H93.7911C96.025 67.7986 97.836 66.0614 97.836 63.9184V47.7776C97.836 45.6347 96.025 43.8975 93.7911 43.8975Z",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.803 54.1402C55.2335 54.1402 56.3932 52.9936 56.3932 51.5794C56.3932 50.1651 55.2335 49.0186 53.803 49.0186C52.3726 49.0186 51.2129 50.1651 51.2129 51.5794C51.2129 52.9936 52.3726 54.1402 53.803 54.1402Z",
    fill: "#D7E8F0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8965 62.6775C46.8965 60.8663 47.624 59.1294 48.9197 57.8489C50.2148 56.568 51.9716 55.8486 53.8036 55.8486C55.6355 55.8486 57.3924 56.568 58.6876 57.8489C59.9832 59.1294 60.7107 60.8663 60.7107 62.6775H46.8965Z",
    fill: "#D7E8F0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6619 94.2598C51.93 94.2607 49.2596 95.0625 46.9884 96.5636C44.7171 98.0648 42.9477 100.198 41.9025 102.694C40.8579 105.19 40.585 107.936 41.1187 110.585C41.6524 113.234 42.968 115.667 44.9005 117.577C46.8326 119.486 49.294 120.787 51.9736 121.313C54.6532 121.84 57.4305 121.569 59.9544 120.535C62.4782 119.501 64.6352 117.751 66.1531 115.505C67.671 113.259 68.481 110.619 68.481 107.918C68.481 106.124 68.1234 104.347 67.429 102.69C66.7342 101.032 65.7167 99.5263 64.433 98.2581C63.1498 96.9899 61.6266 95.9838 59.95 95.2978C58.2734 94.6118 56.4764 94.2588 54.6619 94.2598ZM54.6619 118.279C54.1432 118.254 53.654 118.032 53.296 117.661C52.9379 117.289 52.7381 116.795 52.7381 116.282C52.7381 115.768 52.9379 115.275 53.296 114.903C53.654 114.531 54.1432 114.31 54.6619 114.285C55.1806 114.31 55.6698 114.531 56.0278 114.903C56.3859 115.275 56.5857 115.768 56.5857 116.282C56.5857 116.795 56.3859 117.289 56.0278 117.661C55.6698 118.032 55.1806 118.254 54.6619 118.279ZM57.2119 102.918C56.7861 105.88 56.428 108.989 55.5328 111.869C55.32 112.563 54.0039 112.563 53.791 111.869C53.1605 109.704 52.6757 107.5 52.3394 105.272C52.0636 103.65 51.1055 101.024 52.02 99.4502C52.8281 98.0151 55.1022 97.8716 56.4232 98.6083C58.0441 99.5124 57.4054 101.445 57.2119 102.918Z",
    fill: "#D7E8F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2676 78.8965H86.6118",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2676 85.7246H86.6118",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2676 128.405H86.6118",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6729 134.38H71.0718",
    stroke: "#CCDDE2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTemplate);
export default __webpack_public_path__ + "static/media/home_template.058f9959cf0b90301de690f4ea06fe75.svg";
export { ForwardRef as ReactComponent };